import React from 'react';
import { getLinks } from './resources';
import { generalizeFund } from '../../utils/fund-info';
import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import ResourceLink from '../../components/ResourceLink/ResourceLink';

import styles from './Resources.css';

import { ETF_RESOURCES_QUERY, RESOURCES_QUERY } from './queries';

const ResourcesCard = ({ ticker, etf, transparencyTypeName, moneyMarket }) => {
    const links = getLinks(etf, transparencyTypeName, moneyMarket);
    const splitAt = Math.ceil(links.length / 2);
    const col1 = links.slice(0, splitAt);
    const col2 = links.slice(splitAt);

    return (
        <div>
            <GqlQueryWrapper
                query={etf ? ETF_RESOURCES_QUERY : RESOURCES_QUERY}
                variables={{ ticker }}
                dataFunc={generalizeFund}
            >
                {({
                    data: {
                        fund: { cusip, trpCode }
                    }
                }) => (
                    <section>
                        <div className="resource-card">
                            {col1.map((link) => (
                                <Card key={link.name}>
                                    <ResourceLink
                                        cusip={cusip}
                                        link={link}
                                        trpCode={trpCode}
                                        ticker={ticker}
                                    />
                                </Card>
                            ))}
                        </div>
                        <div className="resource-card">
                            {col2.map((link) => (
                                <Card key={link.name}>
                                    <ResourceLink
                                        cusip={cusip}
                                        link={link}
                                        trpCode={trpCode}
                                        ticker={ticker}
                                    />
                                </Card>
                            ))}
                        </div>
                    </section>
                )}
            </GqlQueryWrapper>
            <style jsx>{styles}</style>
        </div>
    );
};

export default ResourcesCard;
